export type AudioRecorderErrorCode =
  | 'aborted'
  | 'inactive'
  | 'already_used'
  | 'NotAllowedError'
  | 'stream_muted'
  | 'mic_not_allowed'
  | 'mic_not_allowed_dismissed'
  | 'mic_not_found'
  | 'mic_not_readable'
  | 'mic_overconstrained'
  | 'mic_security'
  | 'mic_type_error'
  | 'mic_abort'
  | 'recording_invalid_state'
  | 'recording_not_supported'
  | 'recording_unknown'
  | 'recording_security'
  | 'recording_not_readable'
  | 'browser_not_supported';

export class AudioRecorderError extends Error {
  readonly code: AudioRecorderErrorCode;

  constructor(code: AudioRecorderErrorCode, message?: string) {
    super(message || code);
    this.name = 'AudioRecorderError';
    this.code = code;
  }
}
